import React, { useState, useEffect } from "react";
import classes from "./CashReciept.module.css";
import api, { withCompanyId } from "../../../Components/API/Api";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";

function PayeReceipt({ isOpen, onClose }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);

  const [reference, setReference] = useState("");
  const [type, setType] = useState("");
  const [supplierSearch, setSupplierSearch] = useState("");
  const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
  const navigate = useNavigate();
  const [debitSearch, setDebitSearch] = useState("");
  const [creditSearch, setCreditSearch] = useState("");
  const [showDebitDropdown, setShowDebitDropdown] = useState(false);
  const [showCreditDropdown, setShowCreditDropdown] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [description, setDescription] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [creditAccount, setCreditAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [months, setMonths] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [monthLoading, setMonthLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [selectedPaymentMonth, setSelectedPaymentMonth] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [creditAccounts, setCreditAccounts] = useState([]);
  const [debitAccounts, setDebitAccounts] = useState([]);
  const [employees, setEmployees] = useState([]);
const [employeeLoading, setEmployeeLoading] = useState(false);
const formatMonthYear = (value) => {
  const [year, month] = value.split("-");
  return new Date(year, month - 1).toLocaleString("en-US", {
    month: "long",
    year: "numeric"
  });
};
  const [totalAmount, setTotalAmount] = useState(""); 
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [paymentSearch, setPaymentSearch] = useState("");
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [creditAccountsLoading, setCreditAccountsLoading] = useState(false);
  const [supportingDocument, setSupportingDocument] = useState(null);
  const [supportingError, setSupportingError] = useState("");
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [payableAccountsLoading, setPayableAccountsLoading] = useState(false);
  const [paymentCode, setPaymentCode] = useState("");
  const [processedData, setProcessedData] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) { setSupportingDocument(null); setSupportingError(""); return; }
    if (file.type !== 'application/pdf') { setSupportingError('Only PDF files are allowed.'); setSupportingDocument(null); return; }
    const max = 2 * 1024 * 1024;
    if (file.size > max) { setSupportingError('File must be 2MB or smaller.'); setSupportingDocument(null); return; }
    setSupportingError(""); setSupportingDocument(file);
  };

  // keep handlePrinter as-is
  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      debitAccountName: debitSearch,
      creditAccount,
      creditAccountName: creditSearch,
      totalAmount,
      code: paymentCode,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData },
    });
  };

  // === handleProcess ===
  const handleProcess = async () => {
    try {
      setIsProcessing(true);
      const token = localStorage.getItem("authToken");
      const companyId = localStorage.getItem("company_id");

      const payload = {
        company_id: companyId,
        payment_type: type,
        month: selectedPaymentMonth,
        tax_agent_id: selectedPaymentType,
        description: description,
        mode_of_payment: selectedPaymentMode,
        debit_account_id: debitAccount,
        credit_account_id: creditAccount,
        total_amount: totalAmount,
        employee_id: employees.map((row) => row.employee_id).filter(Boolean),
        employee_number: employees.map((row) => row.employee_number).filter(Boolean),
        name: employees.map((row) => row.name).filter(Boolean),
        stin: employees.map((row) => row.stin).filter(Boolean),
        payee_amount: employees.map((row) => row.payee_amount).filter(Boolean),
      };

      console.log("Process payload:", payload);

      const response = await api.post(
        "/v1/payee_payment/initiate",
        withCompanyId(payload),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        const code = response.data?.data?.payment_code || "";
        setPaymentCode(code);
        setProcessedData(response.data?.data);
        
        Swal.fire({
          imageUrl: verified,
          title: "Payment Processed",
          html: `
            <div style="text-align: center; padding: 20px;">
              <p>${response.data?.message || "The payment has been successfully processed!"}</p>
              <div style="background-color: #f0f0f0; padding: 15px; border-radius: 8px; margin: 20px 0;">
                <p style="margin: 0; font-size: 14px; color: #666;">Payment Code:</p>
                <p style="margin: 10px 0 0 0; font-size: 20px; font-weight: bold; color: #16A34A; word-break: break-all;">${code}</p>
              </div>
            </div>
          `,
          confirmButtonColor: "#16A34A",
          confirmButtonText: "Make Payment",
          showCancelButton: true,
          cancelButtonText: "Close",
          cancelButtonColor: "#6B7280",
          customClass: { popup: "swal-highest-zindex" },
          didOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) swalContainer.style.zIndex = "99999";
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // User clicked "Make Payment" - trigger the submit action with the payment code
            handleSubmit({ preventDefault: () => {} }, code);
          }
        });
      }
    } catch (error) {
      console.error("Process error:", error);
      Swal.fire({
        imageUrl: crop,
        title: "Process Failed",
        text:
          typeof error.response?.data?.message === "object"
            ? Object.values(error.response.data.message).flat().join(", ")
            : error.response?.data?.message ||
              "An error occurred while processing the payment.",
        confirmButtonColor: "#000000ff",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) swalContainer.style.zIndex = "99999";
        },
      });
    } finally {
      setIsProcessing(false);
    }
  };

  // --- Update outstandingAmount when reference (customer selection) changes ---
  useEffect(() => {
    if (!receiptType?.toLowerCase()?.includes("credit customer")) {
      setOutstandingAmount("");
      return;
    }

    if (!reference) {
      setOutstandingAmount("");
      return;
    }

    const customerObj = customerOptions.find(c => String(c.id) === String(reference));
    const balance = customerObj?.balance ?? 0;
    setOutstandingAmount(String(Number(balance) || 0));
  }, [reference, customerOptions, receiptType]);

  // --- Fetch customers (only when receiptType includes credit customer) ---
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit customer")) return;

      try {
        setCustomerLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/customer/get');

        if (res.data && Array.isArray(res.data.data)) {
          setCustomerOptions(res.data.data);
        } else {
          setCustomerOptions([]);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setCustomerOptions([]);
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomers();
  }, [receiptType]);

  // --- Fetch loans (when receiptType includes loan repayment) ---
  useEffect(() => {
    const fetchLoanOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("loan repayment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/loans');

        if (res.data && Array.isArray(res.data.data)) {
          setLoanOptions(res.data.data);
        } else {
          setLoanOptions([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoanOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchLoanOptions();
  }, [receiptType]);

  // --- Fetch employees (when receiptType includes employee payment) ---
  useEffect(() => {
    const fetchEmployeeOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("employee payment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/employee/paginated');

        // Handle paginated response: { status, message, data: { current_page, data: [...], ... } }
        if (res.data && res.data.data?.data && Array.isArray(res.data.data.data)) {
          setEmployeeOptions(res.data.data.data);
        } else {
          setEmployeeOptions([]);
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployeeOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchEmployeeOptions();
  }, [receiptType]);

  // --- Fetch payment types ---
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      setPaymentTypesLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/taxagency', { 
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        });
 const agencies = Array.isArray(res?.data?.data) ? res.data.data : [];
 setPaymentTypes(agencies);
        // if (res.data && Array.isArray(res.data.data)) {
        //   setPaymentTypes(res.data.data);
        // } else {
        //   setPaymentTypes([]);
        // }
      } catch (err) {
        setPaymentTypes([]);
      } finally {
        setPaymentTypesLoading(false);
      }
    };
    fetchPaymentTypes();
  }, []);

useEffect(() => {

  // ❌ Do not call API if tax agent is not selected
  if (!selectedPaymentType) return;

  const fetchMonths = async () => {
    setMonthLoading(true);

    try {

      const token = localStorage.getItem("authToken");
      const companyId = localStorage.getItem("company_id");

      const res = await api.get(
        `/v1/monthly_salary_computation/get_computed_month`,
        {
          params: {
            company_id: companyId,
            tax_agent_id: selectedPaymentType
          },
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
          }
        }
      );

      const agencies = Array.isArray(res?.data?.data) ? res.data.data : [];

      setMonths(agencies);

    } catch (err) {

      setMonths([]);

    } finally {

      setMonthLoading(false);

    }
  };

  fetchMonths();

}, [selectedPaymentType]);

 const formatMoney = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
  };

  

useEffect(() => {

  if (!selectedPaymentMonth || !selectedPaymentType) return;

  const fetchEmployees = async () => {

    setEmployeeLoading(true);

    try {

      const token = localStorage.getItem("authToken");
      const companyId = localStorage.getItem("company_id");

      const res = await api.get(
        "/v1/monthly_salary_computation/payee_employee",
        {
          params: {
            month: selectedPaymentMonth,
            company_id: companyId,
            tax_agent_id: selectedPaymentType
          },
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
          }
        }
      );

      const data = Array.isArray(res?.data?.data?.data) ? res.data.data?.data : [];

      setEmployees(data);

    } catch (error) {

      setEmployees([]);

    } finally {

      setEmployeeLoading(false);

    }
  };

  fetchEmployees();

}, [selectedPaymentMonth, selectedPaymentType]);

  // --- Fetch suppliers when selectedPaymentType includes supplier ---
  useEffect(() => {
    const fetchSuppliers = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("supplier")) {
        setSupplierOptions([]);
        return;
      }

      setSupplierLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/beneficiary');

        const suppliers = res?.data?.data;
        if (Array.isArray(suppliers)) {
          const options = suppliers.map((s) => ({
            id: s.id,
            name: s.supplier_name || s.name || `Supplier ${s.id}`,
          }));
          setSupplierOptions(options);
        } else {
          setSupplierOptions([]);
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
      } finally {
        setSupplierLoading(false);
      }
    };

    fetchSuppliers();
  }, [selectedPaymentType]);

  // --- Fetch Account Names and Codes ---
  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-expense-accounts');
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setAccounts(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchAccounts();
  }, []);

  // --- Fetch Payable Accounts when payment type includes "payable" ---
  useEffect(() => {
    const fetchPayableAccounts = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("payable")) {
        setPayableAccounts([]);
        return;
      }

      setPayableAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-payable-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          setPayableAccounts(res.data.data);
        } else {
          setPayableAccounts([]);
        }
      } catch (err) {
        console.error("Error fetching payable accounts:", err);
        setPayableAccounts([]);
      } finally {
        setPayableAccountsLoading(false);
      }
    };

    fetchPayableAccounts();
  }, [selectedPaymentType]);

  // --- Fetch Payment Methods ---
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/income/get-payment-method');

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  // --- Fetch Currencies ---
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/fetch-all-currencies');

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchCreditAccounts = async () => {
      setDebitAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-payable-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          const creditAccounts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
          }));
          setCreditAccounts(creditAccounts);
        } else {
          setCreditAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching credit accounts:", error);
        setCreditAccounts([]);
      } finally {
        setDebitAccountsLoading(false);
      }
    };

    if (isOpen) fetchCreditAccounts();
  }, [isOpen]);

  useEffect(() => {
    const fetchDebitAccounts = async () => {
      setCreditAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-cash-and-bank');

        if (res.data && Array.isArray(res.data.data)) {
          const debtAccts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
          }));
          
          setDebitAccounts(debtAccts);
        } else {
          setDebitAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching debit accounts:", error);
        setDebitAccounts([]);
      } finally {
        setCreditAccountsLoading(false);
      }
    };

    if (isOpen) fetchDebitAccounts();
  }, [isOpen]);

  if (!isOpen) return null;

  // === TABLE HANDLERS ===
  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_name ?? value?.name ?? ""}`;
        row.accountCode = value?.gl_code ?? value?.code ?? "";
        row.showDropdown = false;
      } else if (field === "accountDisplay") {
        row.accountDisplay = value;
        row.accountId = "";
        row.accountCode = "";
        row.showDropdown = true;
      } else if (field === "amount") {
        row.amount = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = employees.reduce((sum, emp) => {
  return sum + (Number(emp.payee_amount) || 0);
}, 0);
  const isBalanced = totalDebit === totalCredit;

  // === handleSubmit ===
const handleSubmit = async (e, passedCode = null) => {
  e.preventDefault();
  console.log("✅ handleSubmit triggered");

  // Use passed code if provided (from alert), otherwise use state
  const codeToUse = passedCode || paymentCode;
  console.log("Payment code to use:", codeToUse);

  if (!isBalanced) {
    Swal.fire({
      icon: "error",
      title: "Unbalanced Entry",
      text: "Total Debit and Total Credit must balance before saving.",
      confirmButtonColor: "#3085d6",
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalPopup = document.querySelector(".swal2-container");
        if (swalPopup) swalPopup.style.zIndex = "99999";
      },
    });
    return;
  }

  setIsSaving(true);

  try {

    const payload = {
      tax_agent_id: selectedPaymentType,
      payment_type: type,
      month: selectedPaymentMonth,
      transaction_date: transactionDate,
      description: description,
      mode_of_payment: selectedPaymentMode,
      debit_account_id: debitAccount,
      credit_account_id: creditAccount,
      total_amount: totalAmount,
      code: codeToUse,
      employee_id: employees.map((row) => row.employee_id).filter(Boolean),
      employee_number: employees.map((row) => row.employee_number).filter(Boolean),
      name: employees.map((row) => row.name).filter(Boolean),
      stin: employees.map((row) => row.stin).filter(Boolean),
      payee_amount: employees.map((row) => row.payee_amount).filter(Boolean),
    };

    console.log("Submitting payload:", payload);

    const formData = new FormData();

    // Append normal fields
    formData.append("tax_agent_id", payload.tax_agent_id || "");
    formData.append("payment_type", payload.payment_type || "");
    formData.append("month", payload.month || "");
    formData.append("transaction_date", payload.transaction_date || "");
    formData.append("description", payload.description || "");
    formData.append("mode_of_payment", payload.mode_of_payment || "");
    formData.append("debit_account_id", payload.debit_account_id || "");
    formData.append("credit_account_id", payload.credit_account_id || "");
    formData.append("total_amount", payload.total_amount || "");
    formData.append("code", payload.code || "");

    // Append employee arrays
    payload.employee_id.forEach((id) => {
      formData.append("employee_id[]", id);
    });

    payload.employee_number.forEach((num) => {
      formData.append("employee_number[]", num);
    });

    payload.name.forEach((name) => {
      formData.append("name[]", name);
    });

    payload.stin.forEach((stin) => {
      formData.append("stin[]", stin);
    });

    payload.payee_amount.forEach((amount) => {
      formData.append("payee_amount[]", amount);
    });

    // Append file if exists
    if (supportingDocument) {
      formData.append(
        "supporting_document",
        supportingDocument,
        supportingDocument.name
      );
    }

    const response = await api.post(
      "/v1/payee_payment/complete",
      withCompanyId(formData),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        imageUrl: verified,
        title: "Payment Saved",
        text:
          response.data?.message ||
          "The payment has been successfully saved!",
        showDenyButton: true,
        confirmButtonText: "Print",
        denyButtonText: "OK",
        confirmButtonColor: "#16A34A",
        denyButtonColor: "#3085d6",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) swalContainer.style.zIndex = "99999";
        },
      }).then((result) => {
        if (result.isConfirmed) {

          const receiptData = {
            reference,
            transactionDate,
            description,
            selectedCurrency,
            selectedPaymentMode,
            debitAccount,
            debitAccountName: debitSearch,
            creditAccount,
            creditAccountName: creditSearch,
            totalAmount: totalCredit,
            code: paymentCode,
            rows,
          };

          navigate("/preview", {
            state: { invoice: receiptData },
          });

        } else if (result.isDenied) {

          setRows([
            {
              accountId: "",
              accountDisplay: "",
              accountCode: "",
              amount: "",
              showDropdown: false,
            },
          ]);

          setReference("");
          setDescription("");
          setDebitAccount("");
          setTotalAmount("");
          setSelectedPaymentMode("");
          setTransactionDate("");
          onClose();
        }
      });
    }

  } catch (error) {

    console.error("Save error:", error);

    Swal.fire({
      imageUrl: crop,
      title: "Save Failed",
      text:
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join(", ")
          : error.response?.data?.message ||
            "An error occurred while saving the payment.",
      confirmButtonColor: "#000000ff",
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalContainer = document.querySelector(".swal2-container");
        if (swalContainer) swalContainer.style.zIndex = "99999";
      },
    });

  } finally {
    setIsSaving(false);
  }
};

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <h3 className={classes.title}>Tax Remittances:</h3>
        <div className={classes.topRow}>
          {/* <div className={classes.Group3}>
            <label>Payment type</label>
            <select
              value={selectedPaymentType}
              onChange={(e) => {
                const value = e.target.value.toLowerCase().trim();
                setSelectedPaymentType(value);
                setReference("");
              }}
            >
              <option value="">Select Type</option>
              {paymentTypesLoading ? (
                <option>Loading payment types...</option>
              ) : (
                paymentTypes.map((type) => {
                  const name = type.name || type.type_name;
                  return (
                    <option key={type.id} value={name?.toLowerCase()?.trim()}>
                      {name}
                    </option>
                  );
                })
              )}
            </select>
          </div> */}
          <div className={classes.Group} >
            <label>Payment to</label>
            <select
              value={selectedPaymentType}
              onChange={(e) => {
                const id = e.target.value;
                setSelectedPaymentType(id);
                setReference("");
              }}
            >
              <option value="">Select PAYE Agent</option>
              {paymentTypesLoading ? (
                <option>Loading paye agents...</option>
              ) : (
                paymentTypes.map((type) => {
                  const name = `${type.abbreviation} - ${type.agency_name} - ${type.state}`;
                  return (
                    <option key={type.id} value={type.id}>
                      {name}
                    </option>
                  );
                })
              )}
            </select>
          </div>
          <div className={classes.Group}>
            <label>Payment Type</label>
            <select
              value={type}
              onChange={(e) => {
                const value = e.target.value;
                setType(value);
              }}
            >
              <option value="">Select payment type</option>
              <option value="1">Pay As You Earn (PAYE)</option>
              <option value="2">Value Added Tax (VAT)</option>
              <option value="3">Withholding Tax (WHT)</option>
            
            </select>
          </div>
          <div className={classes.Group}>
            <label>Select Month</label>
            <select
              value={selectedPaymentMonth}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedPaymentMonth(value);
                
              }}
            >
              <option value="">Select Month</option>
              {monthLoading ? (
                <option>Loading months...</option>
              ) : (
                months.map((type) => {
                  const name = type.name || type.type_name;
                  return (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  );
                })
              )}
            </select>
          </div>
          <div className={classes.Group}>
            <label>Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
            />
          </div>

          <div className={classes.Group}>
            <label>Currency</label>
            <select
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
            >
              <option value="">Select Currency</option>
              {currencyOptions.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.code || c.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={classes.topRows}>
          <div className={classes.Group1}>
            <label>Description</label>
            <input
              type="text"
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className={classes.Group2}>
            <label>Mode of Payment</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select payment mode..."
                value={paymentSearch}
                onChange={(e) => setPaymentSearch(e.target.value)}
                onFocus={() => setShowPaymentDropdown(true)}
                onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
                className={classes.accountInput}
              />

              {showPaymentDropdown && (
                <div
                  className={classes.dropdownList}
                  onMouseLeave={() => setShowPaymentDropdown(false)}
                >
                  {paymentModes.length === 0 ? (
                    <div>No payment modes found</div>
                  ) : (
                    paymentModes
                      .filter((m) =>
                        (m.name || m.method_name || "").toLowerCase().includes(paymentSearch.toLowerCase())
                      )
                      .map((m) => (
                        <div
                          key={m.id}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setSelectedPaymentMode(m.id);
                            setPaymentSearch(m.name || m.method_name || "");
                            setShowPaymentDropdown(false);
                          }}
                        >
                          {m.name || m.method_name}
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>

          <div className={classes.Group2}>
            <label>Debit Account</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select debit account..."
                value={debitSearch}
                onChange={(e) => setDebitSearch(e.target.value)}
                onFocus={() => setShowDebitDropdown(true)}
                onClick={() => setShowDebitDropdown(!showDebitDropdown)}
                className={classes.accountInput}
                disabled={debitAccountsLoading}
              />

              {showDebitDropdown && (
                <div
                  className={classes.dropdownList}
                  onMouseLeave={() => setShowDebitDropdown(false)}
                >
                  {debitAccountsLoading ? (
                    <div>Loading accounts...</div>
                  ) : creditAccounts.length === 0 ? (
                    <div>No accounts found</div>
                  ) : (
                    creditAccounts
                      .filter((acc) =>
                        (acc.label || "").toLowerCase().includes(debitSearch.toLowerCase())
                      )
                      .map((acc) => (
                        <div
                          key={acc.value}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setDebitAccount(acc.value);
                            setDebitSearch(acc.label || "");
                            setShowDebitDropdown(false);
                          }}
                        >
                          {acc.label}
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={classes.top}>
          <div className={classes.Group2}>
            <label>Credit Account</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select credit account..."
                value={creditSearch}
                onChange={(e) => setCreditSearch(e.target.value)}
                onFocus={() => setShowCreditDropdown(true)}
                onClick={() => setShowCreditDropdown(!showCreditDropdown)}
                className={classes.accountInput}
                disabled={creditAccountsLoading}
              />

           {showCreditDropdown && (
  <div
    className={classes.dropdownList}
    onMouseLeave={() => setShowCreditDropdown(false)}
  >
    {creditAccountsLoading ? (
      <div>Loading accounts...</div>
    ) : debitAccounts.length === 0 ? (
      <div>No accounts found</div>
    ) : (
      debitAccounts
        .filter((acc) =>
          (acc.label || "")
            .toLowerCase()
            .includes(creditSearch.toLowerCase())
        )
        .map((acc) => (
          <div
            key={acc.value}
            className={classes.dropdownItem}
            onClick={() => {
              setCreditAccount(acc.value);
              setCreditSearch(acc.label || "");
              setShowCreditDropdown(false);
            }}
          >
            {acc.label}
          </div>
        ))
    )}
  </div>
)}
            </div>
          </div>
          <div className={classes.Group1}>
            <label>Total Amount</label>
            <input
              type="number"
              placeholder="Enter Amount"
              style={{ textAlign: "right" }}
              value={totalAmount}
              onChange={(e) => setTotalAmount(e.target.value)}
            />
          </div>

          {/* <div className={classes.Group2}>
            <label>Loan Account</label>
            <select
              value={selectedLoanAccount}
              onChange={(e) => setSelectedLoanAccount(e.target.value)}
              disabled
            >
              <option value="">Select Loan Account (Coming Soon)</option>
              <option value="loan-1">Loan #001 - Placeholder</option>
              <option value="loan-2">Loan #002 - Placeholder</option>
            </select>
          </div> */}

          <div className={classes.Group2}>
            <label>Reference/Income/Loan No.</label>
            <input
              type="text"
              placeholder="Enter reference number"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
            />
          </div>

          {(() => {
            const selectedModeName = paymentModes.find(
              (m) => m.id == selectedPaymentMode
            )?.name?.toLowerCase();

            if (selectedModeName?.includes("loan")) {
              return (
                <div className={classes.Group2}>
                  <label>Outstanding</label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={outstandingAmount || ""}
                    disabled
                  />
                </div>
              );
            }
            return null;
          })()}
        </div>

        <div className={classes.Group2}>
          <label>Supporting Document</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            className={classes.fileInput}
          />
          {supportingError && (<div style={{ color: 'red', marginTop: 6 }}>{supportingError}</div>)}
          {supportingDocument && (
            <div style={{ marginTop: 6 }}>
              {supportingDocument.name} <button type="button" onClick={() => { setSupportingDocument(null); setSupportingError(""); }}>Remove</button>
            </div>
          )}
        </div>
<h3 className={classes.title}>Employees:</h3>
        <table className={classes.table}>
          <thead>
            <tr >
              <th>#</th>
              <th style={{textAlign: 'left'}}>STIN</th>
              <th style={{textAlign: 'left'}}>Name</th>
              {/* <th>Description</th> */}
              <th style={{textAlign: 'right'}}>Amount</th>
            </tr>
          </thead>
          <tbody>
              {employeeLoading ? (
    <tr>
      <td colSpan="4" style={{ textAlign: "center" }}>
        Fetching employees...
      </td>
    </tr>
  ) : (
    employees.map((emp, index) => (
      <tr key={index} style={{textAlign: 'center', fontSize: 14}}>
        <td>{index + 1}</td>
        <td style={{textAlign: 'left'}}>{emp.stin || ""}</td>
        <td style={{textAlign: 'left'}}>{emp.name || ""}</td>
        <td style={{textAlign: 'right'}}>{formatMoney(emp.payee_amount)}</td>
      </tr>
    ))
  )}
            {/* {rows.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className={classes.accountCell}>
                  <div className={classes.searchableDropdown}>
                    <input
                      type="text"
                      value={row.accountDisplay}
                      onChange={(e) => handleChange(index, "accountDisplay", e.target.value)}
                      onFocus={() => handleChange(index, "showDropdown", true)}
                      onClick={() =>
                        handleChange(index, "showDropdown", !row.showDropdown)
                      }
                      placeholder="Search or type account..."
                      className={classes.accountInput}
                    />

                    {row.showDropdown && (
                      <div
                        className={classes.dropdownList}
                        onMouseLeave={() => handleChange(index, "showDropdown", false)}
                      >
                        {paymentTypeLower.includes("payable") ? (
                          payableAccountsLoading ? (
                            <div className={classes.dropdownLoading}>
                              <Spinner animation="border" size="sm" />
                            </div>
                          ) : (
                            payableAccounts
                              .filter((acc) => {
                                const search = row.accountDisplay?.toLowerCase() || "";
                                const text = `${acc.gl_code ?? acc.code ?? ""} ${acc.gl_name ?? acc.name ?? acc.account_name ?? ""
                                  }`.toLowerCase();
                                return text.includes(search);
                              })
                              .map((acc) => (
                                <div
                                  key={acc.id}
                                  className={classes.dropdownItem}
                                  onClick={() => handleChange(index, "account", acc)}
                                >
                                  {`${acc.gl_code ?? acc.code ?? ""} - ${acc.gl_name ?? acc.name ?? acc.account_name ?? ""
                                    }`}
                                </div>
                              ))
                          )
                        ) : (
                          accountsLoading ? (
                            <div className={classes.dropdownLoading}>
                              <Spinner animation="border" size="sm" />
                            </div>
                          ) : (
                            accounts
                              .filter((acc) => {
                                const search = row.accountDisplay?.toLowerCase() || "";
                                const text = `${acc.gl_code ?? acc.code ?? ""} ${acc.gl_name ?? acc.name ?? ""
                                  }`.toLowerCase();
                                return text.includes(search);
                              })
                              .map((acc) => (
                                <div
                                  key={acc.id}
                                  className={classes.dropdownItem}
                                  onClick={() => handleChange(index, "account", acc)}
                                >
                                  {`${acc.gl_code ?? acc.code ?? ""} - ${acc.gl_name ?? acc.name ?? ""
                                    }`}
                                </div>
                              ))
                          )
                        )}
                      </div>
                    )}
                  </div>
                </td>

                <td>
                  <input
                    type="text"
                    value={row.accountCode}
                    readOnly
                    className={classes.readOnlyInput}
                  />
                </td>

                <td>
                  <input
                    type="number"
                    className={classes.creditInput}
                    value={row.amount}
                    onChange={(e) =>
                      handleChange(index, "amount", e.target.value)
                    }
                  />
                </td>

                <td>
                  <button
                    onClick={() => duplicateRow(index)}
                    className={classes.linkBtn}
                    disabled={paymentTypeLower.includes("supplier")}
                    style={{
                      opacity: paymentTypeLower.includes("supplier") ? 0.6 : 1,
                      cursor: paymentTypeLower.includes("supplier") ? "not-allowed" : "pointer",
                    }}
                  >
                    Duplicate
                  </button>
                  <button
                    onClick={() => removeRow(index)}
                    className={classes.removeBtn}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))} */}
           
          </tbody>
        </table>

        {/* <div className={classes.actionRow}>
          <button className={classes.addLineBtn} onClick={addLine}>
            + Add Line
          </button>
        </div> */}

        <div className={classes.totalRow}>
          <div className={classes.totalBox}>
            <span>Total Debit</span>
            <strong>{totalDebit.toFixed(2)}</strong>
          </div>
          <div className={classes.totalBox}>
            <span>Total Credit</span>
            <strong>{totalCredit.toFixed(2)}</strong>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={classes.footerButtons}>
            <button
              type="button"
              className={classes.resetBtn}
              onClick={() =>
                setRows([
                  {
                    accountId: "",
                    accountDisplay: "",
                    amount: "",
                    showDropdown: false,
                  },
                ])
              }
            >
              Reset
            </button>

            <button type="button" className={classes.printBtn} onClick={handlePrinter}>
              Print
            </button>

            <button
              type="button"
              className={classes.submitBtn}
              onClick={handleProcess}
              disabled={isProcessing || isSaving}
            >
              {isProcessing ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner animation="border" size="sm" /> Processing...
                </span>
              ) : (
                "Process"
              )}
            </button>
          </div>
        </form>

        <button className={classes.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
}

export default PayeReceipt;